import React, { useEffect, useState } from 'react'
import { Helmet } from "react-helmet";
import { useNavigate } from 'react-router-dom';
import { GetBZBuserProfile } from 'services/Third-party/GetBZBuserProfile';
import useBookingPage from 'services/store/BookingPage';
import { useSearchParams } from "react-router-dom";
import ModalPDPA from 'components/modal/ModalPDPA';
import useLoadedStore from 'services/store/LoadedPage';
import ModalNoMeetingLink from 'components/modal/ModalNoMeetingLink';
const EventEnd2 = () => {
    const { isBooking, setIsBooking } = useLoadedStore();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { profile } = useBookingPage();
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenNoLink, setIsOpenNoLink] = useState(false);
    const userToken = window.localStorage.getItem('userToken');
    const qToken = searchParams.get('token') ?? userToken;
    window.localStorage.setItem('userToken', qToken);
    useEffect(() => {
    }, [])
    return (
        <div>
            <Helmet>
                <title>S-Mom</title>
                <meta name="title" content="S-Mom" />
                <meta name="description" content="" />
                <meta name="keyword" content="" />
                <meta property="og:title" content="" />
                <meta property="og:description" content="" />
                <meta property="og:image" content="" />
                <meta property="og:url" content="" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="" />
            </Helmet>
            <div id="EventEnd1">
                <main>
                    <div className="header">
                        <h>ขออภัย</h>
                        <h1>จำนวนสิทธิ์แลกรับ</h1>
                        <h1>กิจกรรม S-26 UHT x 7-Eleven</h1>
                        <div className='bubble-text'> </div>
                        <div className='bronw-box'>เจอกันใหม่ รอบวันที่ 1 สิงหาคม 2568</div>

                    </div>


                </main>
            </div>

        </div>
    )
}

export default EventEnd2